import { Receipt } from '@mui/icons-material';

export const DocumentType = {
  SalesQuotation: 20,
  CustomerOrder: 21,
  Delivery: 22,
  CompletionCertificate: 27,
  Return: 23,
  DownPaymentRequest: 24,
  DownPayment: 25,
  ARInvoiceManual: 26,
  ARInvoice: 28,
  ARInvoiceModification: 29,
  PurchaseRequest: 30,
  PurchaseQuotation: 10,
  PurchaseOrder: 11,
  PurchaseDelivery: 12,
  GoodsReturn: 13,
  APDownPaymentRequest: 14,
  APDownPayment: 15,
  APInvoice: 16,
  PurchaseOrderVariant: 17,
  InventoryTransfer: 31,
  GoodsReceipt: 32,
  GoodsIssue: 33,
  InventoryCounting: 34,
  InventoryCountingDif: 35,
  ReceiptFromProduction: 36,
  IssueForProduction: 37,
  ProductionOrder: 38,
  ReturnFromProduction: 39,
  IssueForService: 41,
  ReceiptFromService: 42,
  ReturnFromIssue: 40,
  ProjectIssue: 43,
  ProjectReturn: 44,
  CooperationIssue: 45,
  CooperationReturn: 46,
  EmployeeIssue: 47,
  EmployeeReturn: 48,
  ConversionIssue: 49,
  ConversionReceipt: 50,
};

export const DocumentTypeRoutes = {
  [DocumentType.SalesQuotation]: 'SalesQuotation',
  [DocumentType.CustomerOrder]: 'CustomerOrder',
  [DocumentType.Delivery]: 'DeliveryNote',
  [DocumentType.CompletionCertificate]: 'CompletionCertificate',
  [DocumentType.Return]: 'Return',
  [DocumentType.DownPaymentRequest]: 'DownPaymentRequest',
  [DocumentType.DownPayment]: 'DownPayment',
  [DocumentType.ARInvoice]: 'ARInvoice',
  [DocumentType.ARInvoiceManual]: 'ARInvoiceManual',
  [DocumentType.ARInvoiceModification]: 'ARInvoiceModification',
  [DocumentType.PurchaseRequest]: 'PurchaseRequest',
  [DocumentType.PurchaseQuotation]: 'PurchaseQuotation',
  [DocumentType.PurchaseOrder]: 'PurchaseOrder',
  [DocumentType.PurchaseDelivery]: 'PurchaseDeliveryNote',
  [DocumentType.GoodsReturn]: 'GoodsReturn',
  [DocumentType.APDownPaymentRequest]: 'APDownPaymentRequest',
  [DocumentType.APDownPayment]: 'APDownPayment',
  [DocumentType.APInvoice]: 'APInvoice',
  [DocumentType.PurchaseOrderVariant]: 'PurchaseOrderVariant',
  [DocumentType.InventoryTransfer]: 'InventoryTransfer',
  [DocumentType.GoodsReceipt]: 'GoodsReceipt',
  [DocumentType.GoodsIssue]: 'GoodsIssue',
  [DocumentType.InventoryCounting]: 'InventoryCounting',
  [DocumentType.InventoryCountingDif]: 'InventoryCountingDif',
  [DocumentType.ReceiptFromProduction]: 'ReceiptFromProduction',
  [DocumentType.IssueForProduction]: 'IssueForProduction',
  [DocumentType.ProductionOrder]: 'ProductionOrder',
  [DocumentType.IssueForService]: 'IssueForService',
  [DocumentType.ReceiptFromService]: 'ReceiptFromService',
  [DocumentType.ReturnFromProduction]: 'ReturnFromProduction',
  [DocumentType.ReturnFromIssue]: 'ReturnFromIssue',
  [DocumentType.ProjectIssue]: 'ProjectIssueDoc',
  [DocumentType.ProjectReturn]: 'ProjectReturnDoc',
  [DocumentType.CooperationIssue]: 'CooperationIssueDoc',
  [DocumentType.CooperationReturn]: 'CooperationReturnDoc',
  [DocumentType.EmployeeIssue]: 'EmployeeIssueDoc',
  [DocumentType.EmployeeReturn]: 'EmployeeReturnDoc',
  [DocumentType.ConversionIssue]: 'ConversionIssue',
  [DocumentType.ConversionReceipt]: 'ConversionReceipt',
};

export const InvertAccounting = [
  DocumentType.Return,
  DocumentType.GoodsReturn,
  DocumentType.ReturnFromIssue,
  DocumentType.ProjectReturn,
  DocumentType.CooperationReturn,
  DocumentType.EmployeeReturn,
];
